import { Link, useLocation } from "react-router-dom";
import { Flag } from "lucide-react";

export const SiteHeader = () => {
  const location = useLocation();
  const isAdmin = location.pathname.startsWith("/admin");

  return (
    <header
      data-testid="site-header"
      className="border-b border-slate-200 bg-white/80 backdrop-blur-sm sticky top-0 z-40"
    >
      <div className="max-w-6xl mx-auto px-6 h-16 flex items-center justify-between">
        <Link
          to="/"
          data-testid="site-logo-link"
          className="flex items-center gap-2 font-display font-semibold text-lg tracking-tight"
        >
          <span className="w-8 h-8 rounded-md bg-[#065F46] text-white flex items-center justify-center">
            <Flag className="w-4 h-4" />
          </span>
          <span>SwingShape</span>
        </Link>
        <nav className="flex items-center gap-4 text-sm">
          {!isAdmin && (
            <Link
              to="/admin/login"
              data-testid="nav-admin-link"
              className="text-slate-400 hover:text-slate-900 transition-colors hidden sm:inline"
            >
              Admin
            </Link>
          )}
          {isAdmin && (
            <Link
              to="/"
              data-testid="nav-home-link"
              className="text-slate-500 hover:text-slate-900 transition-colors"
            >
              Home
            </Link>
          )}
        </nav>
      </div>
    </header>
  );
};
